module.exports = __webpack_public_path__ + "static/media/themovementdanceacademy.63d25da2.png";